<template>
  <div :class="[isCard ? 'isCard' : '', `omniview-map omniview-map-${uuid}`]">
  </div>
</template>

<script>
import { Gps as GPS } from "@omnicloud/maps-sdk";
import { SLOT_TYPES } from "@/config/layoutConfig";
import layoutMixin from "@/mixins/layoutMixin";
import store from "@/store";
import { v4 as uuidv4 } from 'uuid';
import { getCspNonce } from "@/utils/cspNonce";

const token = window.localStorage.accessToken;

export default {
  mixins: [layoutMixin],
  props: {
    alarm: {
      type: Object,
    },
    units: {
      type: Array
    },
    unit_id: {
      type: String | Number,
    },
    data: {
      type: Object,
      default: null,
    },
    tabInfo: Object,
    isCard: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      SLOT_TYPES,
      uuid: uuidv4(),
      unitsLoaded: false,
      map: null,
    };
  },
  async mounted() {
    if (this.units.length > 0) {
      this.$nextTick(() => this.initMap());
      this.unitsLoaded = true;
    }
  },
  watch: {
    units(value) {
      if (value.length > 0) {
        this.unitsLoaded = true;
        this.$nextTick(() => this.initMap());
      }
    },
    skin() {
      this.initMap();
    },
    '$i18n.locale'(locale) {
      this.map?.setLocale(locale);
    }
  },
  computed: {
    skin() {
      return store.state.appConfig.layout.skin;
    }
  },
  methods: {
    initMap() {
      const selector = `.omniview-map-${this.uuid}`;

      try {
        this.map = new GPS({
          token,
          apiUrl: `${window.__env.VUE_APP_BASE_URL}/v1`,
          mode: 'facility-tracking',
          selector,
        });

        this.map.setConfig({
          container: selector,
          latLng: { lat: 19.39068, lng: -99.2836975 },
          gmapsKey: window.__env.VUE_APP_GMAPS_KEY,
          triggerEvents: true,
          locale: this.$i18n.locale,
          mapId: this.skin === "dark" ? "eac5c4d4f71b58d6" : "SBO",
          nonce: getCspNonce(),
        });

        this.map.onMapReady().then(() => {
          this.map.getDriver().initMap({
            id_facility: this.unit_id,
            alarm: this.alarm || null
          });
        });

      } catch (error) {
        console.error("initMap", error);
      }
    },
    setMapCenter() {
      const unit = this.units.find((u) => u.id === this.unit_id);
      if (unit) {
        this.map.setCenter(
          parseFloat(unit.coordinates.lat),
          parseFloat(unit.coordinates.lng),
          20
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.omniview-map {
  width: 100%;
  height: 100%;
}

.isCard {
  border-radius: 0.8rem;
}
</style>
